import React from 'react'
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

const DrugNameNDCRadio = ({value, onBlur, name}) =>

    <RadioGroup
        row aria-label="position"
        name={name}
        onClick={onBlur}
        value={value}
        id={`MEDCAL_RX_RADIO_BOOLEAN_${Math.floor(Math.random()*(50000-2 +1) + 2)}`}
        data-testid='MEDCAL_RX_RADIO_BOOLEAN'
    >
        <FormControlLabel
            value="drugName"
            control={<Radio color="primary" inputProps={{'data-testid': `${name}_RADIO_TRUE`, 'id': `${name}_RADIO_TRUE` }} />}
            label="Drug Name"
            labelPlacement="end"
        />
        <FormControlLabel
            value="ndc"
            control={<Radio color="primary" inputProps={{'data-testid': `${name}_RADIO_FALSE`, 'id': `${name}_RADIO_FALSE` }} />}
            label="NDC"
            labelPlacement="end"
        />
    </RadioGroup>

export default DrugNameNDCRadio;